<!-- hypercomb-shared/ui/command-shell/command-shell.component.html -->

<div class="command-bar">
  <div class="command-shell" (mousedown)="onShellMouseDown($event)">
    <div class="command-row">

      <span
        class="prompt-glyph"
        [class.armed]="!!armedResource()"
        [attr.aria-label]="armedResource() ? 'armed resource — click to dismiss' : null"
        (mousedown)="onArmedGlyphMouseDown($event)"
      >
        @if (armedResource(); as armed) {
          @if (armed.previewUrl) {
            <img class="prompt-thumb" [src]="armed.previewUrl" alt="" draggable="false" />
          } @else {
            <span class="prompt-thumb prompt-thumb-fallback" aria-hidden="true">{{ armedBadge() || '>' }}</span>
          }
          @if (armed.previewUrl && armedBadge(); as b) {
            <span class="prompt-badge">{{ b }}</span>
          }
        } @else {
          <span class="prompt-chevron" aria-hidden="true">&gt;</span>
        }
      </span>

      <div class="input-wrap">
        <span
          class="ghost"
          aria-hidden="true"
        >{{ ghostValue() }}</span>

        <input
          #shellInput
          class="command-input"
          type="text"
          name="command-input"
          autocomplete="off"
          autocapitalize="off"
          spellcheck="false"
          [placeholder]="placeholder()"
          (keydown)="onKeyDown($event)"
          (input)="onInput()"
        />
      </div>

      @if (indicators().length) {
        <div class="indicators">
          @for (ind of indicators(); track ind.key) {
            @if (ind.dismissable !== false) {
              <button
                class="indicator-pill"
                [title]="ind.label"
                (mousedown)="$event.preventDefault(); indicatorDismiss.emit(ind.key)">
                <span class="indicator-icon">{{ ind.icon }}</span>
                <span class="indicator-x">×</span>
              </button>
            } @else {
              <span class="indicator-pill info" [title]="ind.label">
                <span class="indicator-icon">{{ ind.icon }}</span>
              </span>
            }
          }
        </div>
      }

      @if (showOpenForSubscribersToggle()) {
        <button
          class="open-for-subscribers-btn"
          [class.on]="openForSubscribers()"
          type="button"
          (mousedown)="$event.preventDefault(); openForSubscribersToggle.emit()"
          [attr.aria-label]="openForSubscribersLabel()"
          [attr.aria-pressed]="openForSubscribers()"
          [title]="openForSubscribersLabel()"
        >
          <!-- broadcast / antenna icon — on = filled rays, off = outline -->
          <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <circle cx="12" cy="12" r="2"/>
            <path d="M16.24 7.76a6 6 0 0 1 0 8.49M7.76 16.24a6 6 0 0 1 0-8.49"/>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M4.93 19.07a10 10 0 0 1 0-14.14"/>
          </svg>
        </button>
      }

    </div>
  </div>

  @if (effectiveShowCompletions()) {
    <ul class="command-results" role="listbox">
      @for (s of suggestions(); track $index; let i = $index) {
        <li
          role="option"
          [class.active]="i === getActiveIndex()"
          (mousedown)="onSuggestionMouseDown($event, s, i)"
        >
          @if (colorFor(s); as color) {
            <span class="color-dot" [style.background]="color"></span>
          }
          <span class="typed">{{ typedPart(s) }}</span
          ><span class="rest">{{ restPart(s) }}</span>
          @if (descriptionFor(s); as desc) {
            <span class="slash-desc">{{ desc }}</span>
          }
        </li>
      }
    </ul>
  }
</div>
